<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <span class="font"
            style="display: flex;align-items: center;">资讯文章
        <!-- <div style="padding: 5px;background: yellow;border: 1px solid yellowgreen;font-size: 12px;font-weight: 500;">
          <img src="../../../public/img/mainLogo.png"
               alt=""
               style="width: 14px;height: 14px;" />
          备注：存在子级分类/文章的资讯分类不可删除。
        </div> -->
      </span>
    </div>

    <div class="center"
         style="position:relative">
      <el-form ref="formTool"
               :model="formTool"
               :inline="true"
               style="text-align:left;">
        <el-form-item prop="articleTitle"
                      label="资讯标题"
                      style="margin-left:0px !important">
          <el-input v-model="formTool.articleTitle"
                    clear
                    style="width: 140px;"
                    placeholder="请输入资讯标题"
                    clearable
                    size="small" />
        </el-form-item>
        <el-form-item prop="approvalNumber"
                      label="资讯分类">
          <el-select v-model="sortOne"
                     @change="changeSortOne"
                     clearable
                     style="width: 120px;"
                     size="small"
                     placeholder="请选择">
            <el-option v-for="item in optionsOne"
                       :key="item.id"
                       :label="item.classifyName"
                       :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="sortTwo"
                     @change="changeSortTwo"
                     clearable
                     style="margin-left:10px;width: 120px"
                     size="small"
                     placeholder="请选择">
            <el-option v-for="item in optionsTwo"
                       :key="item.id"
                       :label="item.classifyName"
                       :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="sortThree"
                     clearable
                     style="margin-left:10px;width: 120px"
                     size="small"
                     placeholder="请选择">
            <el-option v-for="item in optionsThree"
                       :key="item.id"
                       :label="item.classifyName"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status"
                      label="状态">
          <el-select v-model="formTool.status"
                     clearable
                     style="margin-left:10px;width: 120px"
                     size="small"
                     placeholder="请选择状态">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="date"
                      label="资讯发布时间">
          <el-date-picker v-model="formTool.date"
                          style="width: 240px;"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small"
                     type="primary"
                     @click="search()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small"
                     @click="reset()">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small"
                     type="primary"
                     @click="addArticle('add')">新建公告</el-button>
        </el-form-item>
      </el-form>

      <div style="height:calc(100% - 62px);overflow:auto">
        <el-table :data="tableData"
                  style="width: 100%;margin-bottom: 20px;"
                  row-key="id">
          <el-table-column type="index"
                           label="序号"
                           width="50">
          </el-table-column>
          <el-table-column prop="articleTitle"
                           label="资讯文章标题"
                           width="360">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;">

                <span>{{scope.row.articleTitle}}</span>
                <img v-if="scope.row.pinnedStatus == '1'"
                     src="@/assets/zhiding.png"
                     style="margin-left: 6px;"
                     width="12px" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="articleClassification"
                           label="资讯分类"
                           width="320">
          </el-table-column>
          <el-table-column prop="publishingPlatform"
                           label="发布平台"
                           width="220">
          </el-table-column>
          <el-table-column prop="status"
                           label="状态">
            <template slot-scope="scope">
              {{ scope.row.status == 'DRAFT' ? '草稿' : scope.row.status == 'PUBLISH' ? '已发布' :scope.row.status == 'RELEASED' ? '待发布' :scope.row.status == 'DELIST' ? '已下架' : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime"
                           label="资讯更新时间"
                           width="160">
          </el-table-column>
          <el-table-column prop="releaseTime"
                           label="资讯发布时间"
                           width="160">
          </el-table-column>
          <el-table-column label="操作"
                           width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 'DRAFT' || scope.row.status == 'DELIST'">
                <el-link :underline="false"
                         type="primary"
                         @click="updateStatus(scope.row,'PUBLISH')"> 发布
                </el-link>
                <el-link :underline="false"
                         style="margin-left:16px"
                         type="primary"
                         @click="queryInformationArticleById('edit',scope.row)"> 编辑
                </el-link>
                <el-link :underline="false"
                         style="margin-left:16px"
                         type="primary"
                         @click="articleDelete(scope.row)"> 删除
                </el-link>
              </span>
              <span v-if="scope.row.status == 'PUBLISH' || scope.row.status == 'RELEASED'">
                <el-link :underline="false"
                         type="primary"
                         @click="updateStatus(scope.row,'DELIST')"> 下架
                </el-link>
                <el-link :underline="false"
                         style="margin-left:16px"
                         type="primary"
                         @click="queryInformationArticleById('detail',scope.row)"> 详情
                </el-link>
                <el-link :underline="false"
                         style="margin-left:16px"
                         type="primary"
                         @click="updatePinnedStatus(scope.row)"> {{ scope.row.pinnedStatus == '1'? '取消置顶':'置顶' }}
                </el-link>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
    <div class="el-page"
         style="padding-right: 24px !important;">
      <Pagination :total="page.total"
                  :page.sync="page.current"
                  :limit.sync="page.size"
                  :page-sizes="page.pageSizes"
                  @pagination="pageChange" />
    </div>
  </div>
</template>

<script>
import { queryInformationClassifyByParentId, queryInformationArticleList, updatePinnedStatus, updateStatus, articleDelete } from '@/api/message/InformationClassification'
import Pagination from '@/components/Pagination'

export default {
  name: 'WareProduct',
  components: { Pagination },
  data () {
    return {
      sortOne: '',
      sortTwo: '',
      sortThree: '',
      optionsOne: [],
      optionsTwo: [],
      optionsThree: [],
      options: [
        {
          label: '草稿',
          value: 'DRAFT',
        },
        {
          label: '待发布',
          value: 'RELEASED',
        },
        {
          label: '已发布',
          value: 'PUBLISH',
        },
        {
          label: '已下架',
          value: 'DELIST',
        },
      ],
      formTool: {
        articleTitle: '',
        status: '',
        date: []
      },
      tableData: [
        {
          id: 1,
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          id: 2,
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          id: 3,
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          children: [
            {
              id: 31,
              date: '2016-05-01',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄',
              children: [
                {
                  id: 36,
                  date: '2016-05-01',
                  children: null,
                  name: '王小虎',
                  address: '上海市普陀区金沙江路 1519 弄'
                }, {
                  id: 37,
                  date: '2016-05-01',
                  children: null,
                  name: '王小虎',
                  address: '上海市普陀区金沙江路 1519 弄'
                }
              ]
            },
            {
              id: 32,
              date: '2016-05-01',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄',
              children: [
                {
                  id: 38,
                  date: '2016-05-01',
                  name: '王小虎',
                  children: null,
                  address: '上海市普陀区金沙江路 1519 弄'
                }, {
                  id: 39,
                  date: '2016-05-01',
                  children: null,
                  name: '王小虎',
                  address: '上海市普陀区金沙江路 1519 弄'
                }
              ]
            }
          ]
        }, {
          id: 4,
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }],
      page: {
        total: 0,
        current: 1,
        size: 20,
        pageSizes: [10, 20, 30, 50]
      }
    }
  },
  computed: {},
  watch: {},
  created () {
    this.queryInformationArticleList()
    this.queryInformationClassifyByParentId(0, '0')
  },
  mounted () {

  },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  methods: {
    // 修改资讯文章状态
    updateStatus (row, type) {
      let params = {
        id: row.id,
        status: type,
      }
      this.$confirm(`请确认是否${params.status == 'PUBLISH' ? '发布' : '下架'}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (new Date(row.releaseTime).getTime() > Date.now() && params.status == 'PUBLISH') {
          params.status = 'RELEASED'
        }
        updateStatus(params).then(res => {
          if (res) {
            let str = params.status == 'PUBLISH' || params.status == 'RELEASED' ? '发布成功' : '下架成功'
            this.$message.success(str)
            this.queryInformationArticleList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });


    },
    // 修改资讯文章置顶状态
    updatePinnedStatus (row) {
      let params = {
        id: row.id,
        pinnedStatus: row.pinnedStatus == '0' ? '1' : '0',
      }
      updatePinnedStatus(params).then(res => {
        if (res) {
          let str = row.pinnedStatus == '0' ? '置顶成功' : '取消置顶成功'
          this.$message.success(str)
          this.queryInformationArticleList()
        }
      })
    },
    // 编辑/详情
    queryInformationArticleById (type, row) {
      this.$router.push({
        path: '/operationCenter/message-editArticle',
        query: {
          type: type,
          id: row.id
        }
      })
    },
    // 删除
    articleDelete (row) {
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        articleDelete(row.id).then(res => {
          if (res) {
            this.$message.success('删除成功')
            this.queryInformationArticleList(1)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    // 切换分页
    pageChange () {
      this.queryInformationArticleList()
    },
    reset () {
      this.$refs.formTool.resetFields()
      this.sortOne = ''
      this.sortTwo = ''
      this.sortThree = ''
    },
    search () {
      this.queryInformationArticleList(1)
    },
    // 列表
    queryInformationArticleList (current) {
      if (current) { // 搜索条件改变从第一页开始查询
        this.page.current = current
      }
      const params = {
        current: this.page.current,
        size: this.page.size,
        articleTitle: this.formTool.articleTitle,
        articlePrimaryClassificationId: this.sortOne,
        articleSecondaryClassificationId: this.sortTwo,
        articleThreeClassificationId: this.sortThree,
        status: this.formTool.status,
        startTime: this.formTool.date?.length ? this.formTool.date[0] : '',
        endTime: this.formTool.date?.length ? this.formTool.date[1] : '',
      }
      queryInformationArticleList(params).then(res => {
        if (res) {
          this.tableData = res.records
          this.page.total = res.total

        } else {
          this.tableData = []
          this.page.total = 0
        }
      })
    },
    // 添加资讯分类
    addArticle (type) {
      this.$router.push({
        path: '/operationCenter/message-editArticle',
        query: {
          type: type
        }
      })
    },
    // 下拉选择改变
    changeSortOne (value) {
      if (value) {
        this.queryInformationClassifyByParentId(value, '1')
      }
    },
    // 下拉选择改变
    changeSortTwo (value) {
      if (value) {
        this.queryInformationClassifyByParentId(value, '2')
      }
    },
    // 查询三级分类
    async queryInformationClassifyByParentId (id, type) {
      queryInformationClassifyByParentId(id).then(res => {
        if (type == '0') {
          this.optionsOne = res
        } else if (type == '1') {
          this.optionsTwo = res
        } else if (type == '2') {
          this.optionsThree = res
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.classification {
  padding: 0px;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
}
.center {
  .el-form-item {
    margin: 0px 0px 0px 10px !important;
  }
  margin-top: 16px;
  padding: 0 24px 0 24px;
  height: calc(100% - 131px);
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shangjia {
    position: absolute;
    z-index: 2;
    bottom: -45px;
  }
}
</style>
